import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { environment } from '@environments/environment';
import { SayfalamaSonuc } from '@models_genel/SayfalamaSonuc'
import { DuyuruInfo } from '@core/models/genel/DuyuruInfo';
import { IslemSonuc } from '@core/models/genel/IslemSonuc';
import { VersiyonBilgileriFilterDto } from '@core/models/genel/VersiyonBilgileriFilterDto';

@Injectable()
export class VersiyonBilgileriService {

  constructor(private http: HttpClient) {
  }

  getData(): Observable<SayfalamaSonuc> {
    return this.http.post<SayfalamaSonuc>(environment.API_HELPDESK_URL + "GetAllVersiyonBilgisiForUI", { params: null });
  }

  getDataByID(filterDto:VersiyonBilgileriFilterDto): Observable<IslemSonuc> {
    return this.http.post<IslemSonuc>(environment.API_HELPDESK_URL + "GetVersiyonBilgisiByID", filterDto);
  }
  
 
}
